import RollbarModule from 'rollbar'

import getConfig from '@utils/getConfig'

// Preserve the prior `const Rollbar = require('rollbar')` (untyped) behavior:
// the old code called `Rollbar.init(...)` and `Rollbar.log(...)` against the
// raw module export with no type checking. Alias as `any` to keep behavior
// identical now that the ESM import carries types.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Rollbar: any = RollbarModule

const ROLLBAR_ACCESSTOKEN = '2ecf298e1d2044feaa370fcbdf345063'

const environment = getConfig('environment')
const enabled = ['test', 'uat', 'production'].includes(environment)

export const Logger = {
  init() {
    Rollbar.init({
      accessToken: ROLLBAR_ACCESSTOKEN,
      captureUncaught: true,
      payload: {
        environment: enabled && environment,
      },
      enabled,
    })
  },
  log(level, name, body) {
    return enabled && Rollbar.log(level, name, body)
  },
}
